import React from 'react';
import { Check, Users, Settings, Palette, FileText } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/Card';
export function HomeownerDecisionsSection() {
  return <section className="py-16 bg-slate-50 md:py-24" data-id="element-418">
      <div className="container mx-auto px-4 md:px-6" data-id="element-419">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-420">
          <h2 className="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl" data-id="element-421">
            What You Decide vs. What We Handle
          </h2>
          <p className="mt-4 text-lg text-slate-600" data-id="element-422">
            We take care of the technical heavy lifting so you can focus on the
            fun part: how you want it to look and work.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-423">
          {/* Your Choices */}
          <Card className="border-primary/20 shadow-lg relative overflow-hidden" data-id="element-424">
            <div className="absolute top-0 left-0 w-full h-1 bg-primary" data-id="element-425"></div>
            <CardHeader data-id="element-426">
              <div className="flex items-center gap-3 mb-2" data-id="element-427">
                <div className="p-2 rounded-lg bg-primary/10 text-primary" data-id="element-428">
                  <Users className="h-6 w-6" data-id="element-429" />
                </div>
                <CardTitle data-id="element-430">YOUR CHOICES</CardTitle>
              </div>
            </CardHeader>
            <CardContent data-id="element-431">
              <ul className="space-y-4" data-id="element-432">
                <li className="flex items-start gap-3" data-id="element-433">
                  <Check className="h-5 w-5 text-primary mt-0.5 shrink-0" data-id="element-434" />
                  <div data-id="element-435">
                    <span className="font-bold text-slate-900" data-id="element-436">
                      Coverage Area
                    </span>
                    <p className="text-sm text-slate-600" data-id="element-437">
                      Full driveway, tire tracks only, or specific walkways?
                    </p>
                  </div>
                </li>
                <li className="flex items-start gap-3" data-id="element-438">
                  <Check className="h-5 w-5 text-primary mt-0.5 shrink-0" data-id="element-439" />
                  <div data-id="element-440">
                    <span className="font-bold text-slate-900" data-id="element-441">
                      Zone Configuration
                    </span>
                    <p className="text-sm text-slate-600" data-id="element-442">
                      Which areas should heat independently?
                    </p>
                  </div>
                </li>
                <li className="flex items-start gap-3" data-id="element-443">
                  <Check className="h-5 w-5 text-primary mt-0.5 shrink-0" data-id="element-444" />
                  <div data-id="element-445">
                    <span className="font-bold text-slate-900" data-id="element-446">
                      Sensor & Automation Level
                    </span>
                    <p className="text-sm text-slate-600" data-id="element-447">
                      Fully automatic, WiFi enabled, or manual override?
                    </p>
                  </div>
                </li>
                <li className="flex items-start gap-3" data-id="element-448">
                  <Check className="h-5 w-5 text-primary mt-0.5 shrink-0" data-id="element-449" />
                  <div data-id="element-450">
                    <span className="font-bold text-slate-900" data-id="element-451">
                      Surface Finish
                    </span>
                    <p className="text-sm text-slate-600" data-id="element-452">
                      Concrete finish style, paver color/pattern, etc.
                    </p>
                  </div>
                </li>
                <li className="flex items-start gap-3" data-id="element-453">
                  <Check className="h-5 w-5 text-primary mt-0.5 shrink-0" data-id="element-454" />
                  <div data-id="element-455">
                    <span className="font-bold text-slate-900" data-id="element-456">
                      Budget Priorities
                    </span>
                    <p className="text-sm text-slate-600" data-id="element-457">
                      Lower upfront cost vs. lower operating cost?
                    </p>
                  </div>
                </li>
              </ul>
            </CardContent>
          </Card>

          {/* We Handle */}
          <Card className="border-slate-200 shadow-md bg-slate-50/50" data-id="element-458">
            <CardHeader data-id="element-459">
              <div className="flex items-center gap-3 mb-2" data-id="element-460">
                <div className="p-2 rounded-lg bg-slate-200 text-slate-700" data-id="element-461">
                  <Settings className="h-6 w-6" data-id="element-462" />
                </div>
                <CardTitle className="text-slate-700" data-id="element-463">WE HANDLE</CardTitle>
              </div>
            </CardHeader>
            <CardContent data-id="element-464">
              <ul className="space-y-4" data-id="element-465">
                <li className="flex items-start gap-3" data-id="element-466">
                  <Check className="h-5 w-5 text-slate-400 mt-0.5 shrink-0" data-id="element-467" />
                  <span className="text-slate-600" data-id="element-468">
                    System design & engineering calculations
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-469">
                  <Check className="h-5 w-5 text-slate-400 mt-0.5 shrink-0" data-id="element-470" />
                  <span className="text-slate-600" data-id="element-471">
                    Electrical & mechanical load planning
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-472">
                  <Check className="h-5 w-5 text-slate-400 mt-0.5 shrink-0" data-id="element-473" />
                  <span className="text-slate-600" data-id="element-474">
                    Permits & inspections (where required)
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-475">
                  <Check className="h-5 w-5 text-slate-400 mt-0.5 shrink-0" data-id="element-476" />
                  <span className="text-slate-600" data-id="element-477">
                    Trades coordination & scheduling
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-478">
                  <Check className="h-5 w-5 text-slate-400 mt-0.5 shrink-0" data-id="element-479" />
                  <span className="text-slate-600" data-id="element-480">
                    Quality testing & documentation
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-481">
                  <Check className="h-5 w-5 text-slate-400 mt-0.5 shrink-0" data-id="element-482" />
                  <span className="text-slate-600" data-id="element-483">
                    Warranty registration & support
                  </span>
                </li>
              </ul>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}